// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__39Y67","col":"CardReaderDesc_col__2Dh8S","label":"CardReaderDesc_label__28i0F"};